import React, { useState } from 'react';
import CartIcon from '@sls-react/static/svg/CartIcon';
import CartLink from '@sls-react/components/Links/CartLink';
import { useCart } from '@sls-react/hooks/cart/useCart';

interface Props {
  showLabel?: boolean;
}

const CartButton: React.FC<Props> = ({ showLabel }) => {
  const { data: cart } = useCart();
  const cartItems = cart?.cart_items || [];

  const [showPing, setShowPing] = useState(false);

  // useUpdateEffect(() => {
  //   if (cartItems.length > 0) {
  //     setShowPing(true);
  //
  //     const timeout = setTimeout(() => setShowPing(false), 4000);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [cartItems.length]);

  return (
    <CartLink
      className={showLabel ? 'flex flex-col items-center text-black' : ''}
    >
      <CartIcon fill="currentColor" />
      {showLabel && <div className="text-xs text-center">Cart</div>}

      {cartItems.length > 0 && (
        <>
          {showPing && (
            <div
              className="absolute px-1 rounded bg-primary-500 animate-ping text-primary-500"
              style={{ top: -5, right: -5 }}
            >
              {cartItems.length}
            </div>
          )}
          <div
            className="absolute px-1 text-xs text-white rounded bg-primary-500"
            style={{ top: -4, right: -4 }}
          >
            {cartItems.length}
          </div>
        </>
      )}
    </CartLink>
  );
};

export default CartButton;
